








export default
  props:
    image:
      type: String
      default: ''
    texts:
      type: Array
      default: ''
    reverse:
      type: Boolean
      default: false
